import _ from 'underscore';
import { getBulkApiErrors } from '@bingads-webui-campaign/api-errors';
import { notificationApi } from '@bingads-webui-campaign/notification-center';

const getUnexpectedError = i18n => ([{
  message: i18n.getString(_TL_("We've encountered an error and could not finish this task. Please try again or contact support.")),
}]);

const getBulkEditResponseErrors = (response, i18n, scenario) => {
  if (!response || !response.errors) {
    return getUnexpectedError(i18n);
  }

  const errors = getBulkApiErrors(response.errors, scenario, i18n);

  if (!errors || !errors[0] || !errors[0].message) {
    return getUnexpectedError(i18n);
  }

  // error is a api error class
  return _.map(errors, error => ({ message: error.message }));
};

// Handle errors in many scenarios:
// 1. The request failed: the response code != 200;
// 2. Only one campaign is updated in the request: The response is an object with either entity or errors;
// 3. Many campaigns are updated, and some success and some fail:
// The response has many items, and one item may have both many entity and many errors.
export function parseResponseMany(response, i18n) {
  let serverErrors = [];
  const checkAndGetError = (item) => {
    if (_.isArray(item)) {
      item.forEach((i) => {
        checkAndGetError(i);
      });
    } else if (!item || _.isEmpty(item.entity) || !_.isEmpty(item.errors)) {
      const err = getBulkEditResponseErrors(item, i18n);
      serverErrors = _.union(serverErrors, err);
    }
  };

  checkAndGetError(response);
  return serverErrors;
}

export function showErrorBanner({ response, i18n }) {
  const serverErrors = parseResponseMany(response, i18n);
  if (serverErrors.length > 0) {
    notificationApi.showWarning(serverErrors[0].message);
  } else {
    notificationApi.showInfo(i18n.getString(_TL_('Budget suggestions successfully applied.')));
  }
}
